exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#partner-call-send{position:fixed;z-index:99999;width:300px;height:60px;background-color:#242424;border-radius:10px;left:50%;top:50%;margin-top:-50px;margin-left:-150px;padding:10px}.wrap-msg{width:100%;height:100%;position:relative}.wrap-msg p{font-family:TextProLight;font-size:12pt;margin-top:0;padding-top:20px}.cross-exit{width:10px;height:10px;position:absolute;top:0;right:0;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-31421986","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PartnerCallSend.vue
// module id = 145
// module chunks = 0